import useQuery, { useRevalidate } from "./useQuery";
import type { Input, Output } from "./call";
import React from "react";
import { usePatch } from "./useCall";

export const useClassificationFailuresUpdate = () => {
  const updateFailures = usePatch("/failures");
  const revalidate = useRevalidate();

  return React.useCallback(
    async (input: Input<"PATCH", "/failures">) => {
      const res = await updateFailures(input);
      void revalidate("/failures");

      return res;
    },
    [revalidate, updateFailures],
  );
};

export const useClassificationFailures = (input: Input<"GET", "/failures">) =>
  useQuery("/failures", { ...input, keepFresh: true })["body"];

export type ClassificationFailure = Output<"GET", "/failures">["body"]["elements"][number];
